import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router';
import { RoutePath } from '@constants/routes';

const AuthRoute = () => {
    const { state } = useLocation();
    const user = useSelector(state => state.auth.user);

    if (user) {
        if (user?.onboardingCompleted) {
            return <Navigate to={RoutePath.Home} replace />;
        }
        const onboardingAfterGoogle =
            state?.from?.pathname === RoutePath.Onboarding && !!state?.from?.search ? state?.from?.search : '';
        if (!user?.onboardingCompleted) {
            return <Navigate to={`${RoutePath.Onboarding}${onboardingAfterGoogle}`} replace />;
        }
    }

    return <Outlet />;
};

export default AuthRoute;
